import { makeOffer, searchAdverts, searchAdWatchAdverts } from '../../../services/adverts'
import { getCurrentAuction } from '../../../services/auctions'
import { makeBid } from '../../../services/bids'
import { getEmployerSearchOccupations } from '../../../services/stat'

export default {
  searchAdverts ({ commit }, { data }) {
    return new Promise((resolve, reject) => {
      searchAdverts(data)
        .then(response => {
          const adverts = response.data
          commit('setArenaFilter', { filter: data })
          commit('setArenaAdverts', { adverts })
          resolve(adverts)
        })
        .catch(reject)
    })
  },

  searchAdWatchAdverts ({ commit }, { data }) {
    return new Promise((resolve, reject) => {
      searchAdWatchAdverts(data)
        .then(response => {
          const adverts = response.data
          commit('setArenaAdverts', { adverts })
          resolve(adverts)
        })
        .catch(reject)
    })
  },

  getCurrentAuction ({ commit }) {
    return new Promise((resolve, reject) => {
      getCurrentAuction()
        .then(response => {
          const { id, intervalFrom, intervalTo } = response.data
          commit('setAuctionId', { id })
          commit('setIntervalFrom', { intervalFrom })
          commit('setIntervalTo', { intervalTo })
          resolve(true)
        })
        .catch(reject)
    })
  },

  getStockExchangeEmployerSearchOccupations ({ commit }, params) {
    return new Promise((resolve, reject) => {
      getEmployerSearchOccupations(params)
        .then(response => {
          const occupations = response.data
          commit('setStockExchangeEmployerSearchOccupations', { occupations })
          resolve(occupations)
        })
        .catch(reject)
    })
  },

  makeBid ({ commit }, { bid }) {
    return new Promise((resolve, reject) => {
      makeBid(bid)
        .then(response => {
          const lastBid = response.data
          const bidSession = {
            ...lastBid.bidsession,
            lastBidderOccupation: lastBid.bidderOccupation
          }

          commit('makeBid', {
            id: bid.advert.id,
            bidSession
          })
          commit('clearSelectedBidCard')
          resolve(true)
        })
        .catch(reject)
    })
  },

  makeOffer ({ commit }, { id, offer }) {
    return new Promise((resolve, reject) => {
      makeOffer(id, offer)
        .then(() => {
          commit('clearSelectedBidCard')
          resolve(true)
        })
        .catch(reject)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/arena/actions.js